import type { CancelablePromise } from "../client"
import { OpenAPI } from "../client"
import { request as __request } from "../client/core/request"

export type InitExReleaseDraftDTO = {
  warehouse_id: string
  contragent_id?: string
  receiver?: string
  description?: string
}

export type ExReleaseDraftInitResponseDTO = {
  id: string
  number: string
  status: string
  created_at: string
}

export const ExReleaseDraftsService = {
  initExReleaseDraft: (
    payload: InitExReleaseDraftDTO,
  ): CancelablePromise<ExReleaseDraftInitResponseDTO> =>
    __request(OpenAPI, {
      method: "POST",
      url: "/v1/external-releases/drafts",
      body: payload,
      mediaType: "application/json",
    }),
  deleteExReleaseDraft: (id: string): CancelablePromise<void> =>
    __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/external-releases/{id}",
      path: {
        id,
      },
    }),
}
